import React, { Fragment } from 'react'
import { observer, inject } from 'mobx-react'

import anchorScroll from '../utils/anchorScroll'
import isLead from '../utils/isLead'
import Explore from './Explore'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faFacebookF, faInstagram, faYoutube } from "@fortawesome/free-brands-svg-icons"
import config from '../utils/config'

const Footer = ({ commonStore, translationStore, errorStore, location }) => {
  if (location.pathname === '/lpage') {
    return <Fragment />
  }

  return (
    <React.Fragment>

    { commonStore.withHeader &&
        <footer className='footer'>
          {
            isLead(location) && <div className='' />
          }
          <div className='footer__inner'>
          <div className='footer__inner__item'>
            <a href='/' className='footer__logo'>
              <img className='logo' src="/icons/logo-bonusbay.svg" alt="Logo" />
            </a>
          </div>
            <div className='footer__inner__item'>
              <h4>{translationStore.translate('footer_headline_shops_deals')}</h4>
              <Explore location={location} />
            </div>

            <div className='footer__inner__item'>
              <h4>{translationStore.translate('footer_headline_company')}</h4>
              <ul>
                <li>
                  <a onClick={() => anchorScroll('top', '/faq')}>{translationStore.translate('footer_support_general')}</a>
                </li>
                <li>
                  <a onClick={() => anchorScroll('#cashback', '/faq')}>{translationStore.translate('footer_support_cashback')}</a>
                </li>
                <li>
                  <a onClick={() => anchorScroll('#payoff', '/faq')}>{translationStore.translate('footer_support_payoff')}</a>
                </li>
                <li>
                  <a onClick={() => anchorScroll('#account', '/faq')}>{translationStore.translate('footer_support_account')}</a>
                </li>
                <li>
                  <a onClick={() => anchorScroll('top', '/contact')}>{translationStore.translate('footer_contact')}</a>
                </li>
              </ul>
              {
                (!commonStore.isLoggedIn)
                  ? (<ul>
                    <li>
                      <a onClick={() => anchorScroll('top', '/registration')}>{translationStore.translate('footer_my_register')}</a>
                    </li>
                    <li>
                      <a onClick={() => anchorScroll('top', '/login')}>{translationStore.translate('footer_my_login')}</a>
                    </li>
                  </ul>)
                  : (<ul>
                    <li>
                      <a onClick={() => anchorScroll('top', '/profile')}>{translationStore.translate('footer_my_account')}</a>
                    </li>
                  </ul>)
              }
            </div>
 
          </div>
          <div className='footer__after'>
              <p>© {(new Date().getFullYear())} BonusBay</p>
              <a onClick={() => anchorScroll('top', '/page/privacy')}>{translationStore.translate('footer_privacy')}</a>
              <a onClick={() => anchorScroll('top', '/page/gtc')}>{translationStore.translate('footer_gtc')}</a>
              <a onClick={() => anchorScroll('top', '/page/imprint')}>{translationStore.translate('footer_imprint')}</a>
          </div>
        </footer>
    }
    </React.Fragment>
  )
}

export default inject('commonStore', 'translationStore', 'errorStore')(observer(Footer))



// WEBPACK FOOTER //
// ./src/components/Footer.js